import { render, staticRenderFns } from "./NoPermissionsView.vue?vue&type=template&id=2e646c30&scoped=true"
import script from "./NoPermissionsView.vue?vue&type=script&lang=js"
export * from "./NoPermissionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e646c30",
  null
  
)

export default component.exports